import React from 'react';

const Videotour = () => {
    return (
        <div  style={{marginTop: 100, marginBottom: 100}}>
            <iframe  src="https://navse360.ru/onlyTour/13307" width="100%" height="500px" frameBorder="0"
                    scrolling="no">Здесь мог бы быть виртуальный тур, но ваш браузер не поддерживает фреймы.
            </iframe>
        </div>
    );
};

export default Videotour;
